module.exports = __webpack_public_path__ + "static/img/gongsi.1dd3d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gongsi.png
// module id = Ou/u
// module chunks = 1